import React from 'react'
import { string, bool, number, any } from 'prop-types'
import styled, { withTheme } from 'styled-components'
import { rem } from 'polished'
import { Flex, Box } from 'rebass'
import { media } from '../../utils/style'
import typography from '../../utils/typography'

const Section = styled(({ left, offset, title, ...rest }) => (
  <Flex {...rest} />
))`
  position: relative;
  z-index: 1;
  display: block;
  width: 100%;
  overflow: hidden;
  background-color: ${(props) => props.bg};
  ${media.LargeScreenUp`
    background-color: ${(props) => props.theme.colors.blue_light};
  `};
  &::before {
    display: none;
    ${media.LargeScreenUp`
    display: block;
    `};
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    background-color: ${(props) => props.bg};
    width: 100%;
    height: ${(props) => (props.offset ? '140vh' : '100%')};
    z-index: 0;
  }
  &::after {
    display: none;
    ${media.LargeScreenUp`
    display: block;
    `};
    content: '${(props) => props.title}';
    text-transform: uppercase;
    font-weight: ${(props) => props.theme.weights[1]};
    font-size: ${rem(300)};
    line-height: 1;
    position: absolute;
    top: ${(props) => (props.offset ? '13%' : '0')};
    left: ${(props) => (props.left ? '125px' : 'calc(100% - 80px)')};
    float: left;
    transform: rotate(90deg) translateY(-50%);
    transform-origin: left top 0;
    padding: 0;
    margin: 0;
    color: ${(props) => props.fg};
    opacity: ${(props) => props.opacity};
    z-index: 0;
  }
`

const Content = styled(Box)`
  position: relative;
  z-index: 1;
  width: 100%;
`

class ContentSection extends React.PureComponent {
  render() {
    return (
      <Section
        pt={[typography.rhythm(0.1), null, typography.rhythm(1)]}
        pb={
          this.props.pb || [typography.rhythm(0.8), null, typography.rhythm(1)]
        }
        bg={this.props.bg || this.props.theme.colors.blue}
        fg={this.props.fg || this.props.theme.colors.white}
        opacity={this.props.opacity}
        offset={this.props.offset}
        title={this.props.title}
        as="section"
        mx="auto"
        left={this.props.left}
        id={this.props.id}
      >
        <Content>{this.props.children}</Content>
      </Section>
    )
  }
}

ContentSection.defaultProps = {
  bg: '',
  fg: '',
  opacity: 0.15,
  title: '',
  left: false,
  offset: false,
  mt: typography.rhythm(1)
}
ContentSection.propTypes = {
  bg: string,
  fg: string,
  opacity: number,
  title: string,
  left: bool,
  offset: bool,
  mt: any,
  pb: any,
  id: string
}

const Themed = withTheme(ContentSection)
Themed.displayName = 'ContentSection'

export default Themed
